import { createContextProvider } from "../components/store-utils"
import { Lead, Page, Question, QuestionData, Trait, TraitResult } from "./model"

import data from '../data/questions.json';
import { getAsPages } from "../utils";
import { CourseList, loadCourses } from "./api";
import { Dispatch } from "react";


export type TraitState = {
    pages?: Page[]
    currentPage?: number
    lead?: Lead
    traitResult?: TraitResult
    courses?: CourseList
}

export type TraitAction = {type: "answer", page: number, question: number, answer: Trait} |
    {type: "setPage", page: number} |
    {type: "setResult", result: TraitResult} |
    {type: "setLead", lead: Lead} |
    {type: "setCourses", courses: CourseList} 


function answer(pages:Page[], page: number, question: number, answer: Trait):Page[]{
    return pages.map((p, i):Page => {
        return i != page ? p : {...p, questions: p.questions.map((q, j):Question => {
            return j == question ? {...q, selected: answer} : q;
        })}
    });
}

function reducer(state: TraitState, action: TraitAction):TraitState {
    switch(action.type){
        case "answer":  return {...state, pages:answer(state.pages, action.page, action.question, action.answer)}
        case "setPage": return {...state, currentPage: action.page}
        case "setLead": return {...state, lead: action.lead}
        case "setResult": return {...state, traitResult: action.result}
        case "setCourses": return {...state, courses: action.courses}
        default: return state;
    }
}

function createPages(data:QuestionData[]):Page[]{
    //data = data.slice(0,4);
    const questions:Question[]  = data.map((q, m) => ({index: m + 1, text: q.text, options: Object.entries(q.options).map(([k, v]) => ({type: k as Trait, text: v})) }))
    questions.forEach(q => q.options.sort(() => Math.random() > .5 ? 1 : -1))
    return getAsPages(questions, 4).map(p => ({questions: p.items}));
}

const pages = createPages(data as QuestionData[]);

export const [TraitContext, TraitStore] = createContextProvider(reducer, {pages, currentPage:0})


export function save(data:Pick<TraitState, "lead" | "traitResult">){
    const a = {lead: data.lead, traitResult: data.traitResult}
    localStorage.setItem('trait', JSON.stringify(a));
}

export function reset(){
    localStorage.removeItem('trait');
    window.location.reload();
}

export async function restore(dispatch:React.Dispatch<TraitAction>){
    const data = localStorage.getItem('trait');
    if(!data) return;
    if(data) {
        const state = JSON.parse(data) as TraitState;
        
        if(state.lead && state.traitResult){
            const courses = await loadCourses();
            dispatch({type: "setLead", lead: state.lead})
            dispatch({type: "setResult", result: state.traitResult})
            dispatch({type: "setCourses", courses: courses})
        }
    }
}